import { jsx as _jsx } from "react/jsx-runtime";
// 1. Ant Design
// (нет)
// 2. External libraries
import { observer } from "mobx-react-lite";
import { useEffect } from "react";
// 3. Internal components
import ReportPanel from "@/components/Company/ReportPanel";
// 4. Stores
import { getRootStore } from "@/stores/RootStore";
// 5. Types, utils, styles
// (нет)
/**
 * Вкладка «Отчёт» (P-8, UC1124): отчёт по заказам компании за период и выгрузка в Excel.
 * Доступна обеим ролям (DISPATCHER, ADMINISTRATOR) — данные только из `corp_report_orders`/`v_corp_orders`,
 * без обращений к финансовым представлениям (balances/ledger/invoices/payments).
 * Рендеринг вынесен в `ReportPanel` (переиспользуется корп-кабинетом, UC1135) — эта обёртка
 * отвечает только за чтение сторов персонала и жизненный цикл `companyReportStore`.
 */
const ReportTab = observer(() => {
    const { singleCompanyStore, companyReportStore } = getRootStore();
    const company = singleCompanyStore.company;
    const companyId = company?.id ?? null;
    useEffect(() => {
        if (!companyId)
            return undefined;
        void companyReportStore.init(companyId);
        return () => companyReportStore.dispose();
    }, [companyId]);
    if (!company)
        return null;
    return _jsx(ReportPanel, { store: companyReportStore, companyName: company.name });
});
ReportTab.displayName = "ReportTab";
export default ReportTab;
